import type { TourId } from './tours';

const STORAGE_PREFIX = 'cohaven:productTour:';

/**
 * Whether this member has already been walked through a tour.
 *
 * Per user rather than per device-wide key: two people sharing a laptop each
 * get their own first run. A tour nobody can store (private mode, storage
 * blocked) reads as "seen", so a broken localStorage costs a tour rather than
 * replaying it on every visit.
 */
export function hasSeenTour(userId: string | null | undefined, tourId: TourId): boolean {
    if (!userId || typeof window === 'undefined') return true;
    try {
        return window.localStorage.getItem(`${STORAGE_PREFIX}${userId}:${tourId}`) !== null;
    } catch {
        return true;
    }
}

export function markTourSeen(userId: string | null | undefined, tourId: TourId): void {
    if (!userId || typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(`${STORAGE_PREFIX}${userId}:${tourId}`, new Date().toISOString());
    } catch {
        /* storage unavailable — the tour still runs for this session */
    }
}
